import { TreatmentPlanForClipboard } from "./TreatmentPlan";

export function DiagnosisForClipboard({
  noteCodes,
  icdCodesList,
}: {
  noteCodes: NoteCodes;
  icdCodesList: ICDCodesList;
}) {
  return (
    <div>
      <h2>Diagnosis</h2>
      <div>ICD-10 Diagnosis code</div>
      {noteCodes.diagnosis_codes
        ?.filter((el) => el.id)
        ?.map(({ id, treatment_plan }) => (
          <div>
            <h3 key={id}>
              {id} - {icdCodesList[id]}
            </h3>
            <TreatmentPlanForClipboard treatmentPlan={treatment_plan} />
          </div>
        ))}
    </div>
  );
}
